import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_SOURCE, TRIGGER_TYPE } from './globals';
import { trackEvent } from '../../analytics';

const EVENT_TEMPLATE_ID = '171';

// https://dataportal.zillowgroup.net/event-registry/9308
export const emitAttachmentWarningModalImpressionEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '9308',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: TRIGGER_SOURCE.ViewAttachmentModal,
      trigger_object_nm: 'attachment',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
  });

// https://dataportal.zillowgroup.net/event-registry/9309
export const emitViewAttachmentButtonClickEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '9309',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: TRIGGER_SOURCE.ViewAttachmentModal,
      trigger_object_nm: 'view_attachment_button',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
  });
